module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "announcement"
  }, [_c('div', {
    staticClass: "announcement__text"
  }, [_vm._l((_vm.announcementText), function(item, index) {
    return [(index != 0) ? _c('span', [_vm._v("|")]) : _vm._e(), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.formatUrl(item.url)
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                ")])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "announcement__image"
  }, [_vm._l((_vm.announcementImage), function(item) {
    return [_c('a', {
      attrs: {
        "href": _vm.formatUrl(item.url)
      }
    }, [_c('img', {
      attrs: {
        "src": '//img.souche.com/' + item.image,
        "title": item.text,
        "alt": item.text
      }
    })])]
  })], 2), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "other"
  }, [_c('a', {
    attrs: {
      "href": "/?__mobile=true"
    }
  }, [_vm._v("进入手机版")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-508fae43!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/footer/components/Announcement.vue
// module id = 106
// module chunks = 2 3 4 5